import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=0b1c47bf&"
import script from "./RateForm.vue?vue&type=script&lang=js&"
export * from "./RateForm.vue?vue&type=script&lang=js&"
import style0 from "./RateForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports